import { LlmMessage } from '~/atoms/schemas/workflowSchemas';
import { TaskEntry } from '~/lib/workflows/useWorkflows';

/**
 * Extracts all LLM messages from task state events
 * @param tasks Array of task entries
 * @returns Array of LLM messages extracted from all tasks
 */
export const extractMessagesFromTasks = (tasks: TaskEntry[]): LlmMessage[] => {
  return tasks.reduce<LlmMessage[]>((messages, task) => {
    if (!task.taskState || !task.taskState.events) return messages;

    const taskMessages = Object.values(task.taskState.events).reduce<
      LlmMessage[]
    >((eventMessages, taskEvent) => {
      if (!taskEvent.llm_messages) return eventMessages;

      // Add all messages from this event
      return [...eventMessages, ...taskEvent.llm_messages];
    }, []);

    return [...messages, ...taskMessages];
  }, []);
};
